export default {
	clients: [
		{
			id: 1,
			name: 'Soriano Group',
			code: 'G0010700',
			type: 'Grupo',
			parent: 0,
			owner: 'Natividad Hergueta',
			rfc: 'HLQ090319YUW',
			since: '2002',
			clientSince: '2010',
			pais_cabecera: 'Mexico',
			examen: false,

		},
		{
			id: 2,
			code: '0010110',
			type: 'Cliente',
			name: 'Soriano Internacional SA de CV',
			rfc: 'SIN121107A92',
			since: '2002',
			clientSince: '2010',
			parent: 1,
			owner: 'Natividad Hergueta',
			activity: 'Tienda de Autoservicio',
			pais_cabecera: 'Mexico',
			examen: false,
		},
		{
			id: 4,
			name: 'Grupo Test 2',
			code: 'G0021710',
			type: 'Grupo',
			parent: 0,
			owner: 'Natividad Hergueta',
			rfc: 'HLQ090319YUW',
			examen: false,

		},
		{
			id: 2,
			name: 'Cliente 2.1',
			code: '0010110',
			type: 'Cliente',
			parent: 4,
			owner: 'Natividad Hergueta',
			rfc: 'HLQ090319YUW',
			examen: false,
		},
		{
			id: 3,
			name: 'Cliente 2.2',
			code: '0020112',
			type: 'Cliente',
			parent: 4,
			owner: 'Natividad Hergueta',
			rfc: 'HLQ090319YUW',
			examen: false,
		},

		{
			id: 5,
			code: '0010110',
			type: 'Grupo',
			name: 'Grupo Don Ramitos',
			rfc: 'SIN121107A92',
			since: '1994',
			clientSince: '2003',
			parent: 0,
			owner: '',
			activity: 'Compraventa de aparatos eléctricos',
			pais_cabecera: 'Mexico',
			examen: false,
		},
		{
			id: 6,
			code: '0010110',
			type: 'Cliente',
			name: 'Agrotecama SA de CV',
			rfc: 'CAN940705AM7',
			since: '1994',
			clientSince: '2003',
			parent: 5,
			owner: '',
			activity: '',
			pais_cabecera: 'Mexico',
			examen: false,
		},
		{
			id: 7,
			code: '0010110',
			type: 'Cliente',
			name: 'Servicio Sujuxi SA de CV',
			rfc: 'CAN940705AM7',
			since: '1994',
			clientSince: '2003',
			parent: 5,
			owner: '',
			activity: '',
			pais_cabecera: 'Mexico',
			examen: false,
		},
		{
			id: 8,
			code: '0010110',
			type: 'Cliente',
			name: 'Transportes Ayan SA de CV',
			rfc: 'CAN940705AM7',
			since: '1994',
			clientSince: '2003',
			parent: 5,
			owner: '',
			activity: '',
			pais_cabecera: 'Mexico',
			examen: false,
		},
		{
			id: 8,
			code: '0010110',
			type: 'Cliente',
			name: 'Metapel SA de CV',
			rfc: 'CAN940705AM7',
			since: '1994',
			clientSince: '2003',
			parent: 5,
			owner: '',
			activity: '',
			pais_cabecera: 'Mexico',
			examen: false,
		},
		{
			id: 9,
			code: '0010110',
			type: 'Cliente',
			name: 'El Juan Drio SA de SV',
			rfc: 'CAN940705AM7',
			since: '1994',
			clientSince: '2003',
			parent: 5,
			owner: '',
			activity: '',
			pais_cabecera: 'Mexico',
			examen: false,
		},
		{
			id: 10,
			code: '0010110',
			type: 'Cliente',
			name: 'Inmobiliaria San Juan N Lugo Sa de Cv',
			rfc: 'CAN940705AM7',
			since: '1994',
			clientSince: '2003',
			parent: 5,
			owner: '',
			activity: '',
			pais_cabecera: 'Mexico',
			examen: false,
		},
		{
			id: 11,
			code: '3PHABW8MH1G3',
			type: 'Grupo',
			name: 'Comercializadora del Sureste S.A de C.V.',
			rfc: 'FCS470214EY5',
			since: '1947',
			clientSince: '1995',
			parent: 0,
			owner: '',
			activity: 'Venta de camiones, motores, maquinaria pesada, maquinaria agrícola, distribución de automóviles, así como repuestos y alquiler de maquinaria y vehículos.',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 12,
			code: '',
			type: 'Cliente',
			name: 'Embotelladora del Sureste SA de CV',
			rfc: 'MIN991906-AR4',
			since: '1960',
			clientSince: '1988',
			parent: 11,
			owner: '',
			activity: 'minería, el transporte y la infraestructura.',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 13,
			code: '',
			type: 'Cliente',
			name: 'Sureste Industrial SA de CV',
			rfc: 'MIN991906-AR4',
			since: '1960',
			clientSince: '1988',
			parent: 11,
			owner: '',
			activity: 'minería, el transporte y la infraestructura.',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 14,
			code: '',
			type: 'Cliente',
			name: 'Grupo Financiero del Sureste SA de CV',
			rfc: 'MIN991906-AR4',
			since: '1960',
			clientSince: '1988',
			parent: 11,
			owner: '',
			activity: '',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 15,
			code: '',
			type: 'Cliente',
			name: 'Sureste Motriz',
			rfc: 'MIN991906-AR4',
			since: '1960',
			clientSince: '1988',
			parent: 11,
			owner: '',
			activity: '',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 16,
			code: 'YZWE6KBM3WF9',
			type: 'Grupo',
			name: 'Grupo Kraken SA de CV',
			rfc: 'FCS470214EY5',
			since: '1990',
			clientSince: '1995',
			parent: 0,
			owner: '',
			activity: 'fabricación de compuestos rígidos y flexibles para la industria del plástico',
			pais_cabecera: 'Mexico',
			examen: true,
		},
	
		{
			id: 17,
			code: '',
			type: 'Cliente',
			name: 'Mexicos S.A.B. de C.V',
			rfc: 'FCS470214EY5',
			since: '1960',
			clientSince: '1988',
			parent: 17,
			owner: '',
			activity: 'producción y venta de productos químicos y petroquímicos',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 18,
			code: '',
			type: 'Cliente',
			name: 'Consmexica S.A. de C.V',
			rfc: 'MIN991906-AR4',
			since: '1960',
			clientSince: '1988',
			parent: 0,
			owner: '',
			activity: 'Construccion Industrial',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 19,
			code: 'GME850421UKZ',
			type: 'Grupo',
			name: 'México de Metales Internacionales SAB',
			rfc: 'FCS470214EY5',
			since: '1947',
			clientSince: '1995',
			parent: 0,
			owner: '',
			activity: 'minería, el transporte y la infraestructura.',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 20,
			code: '',
			type: 'Cliente',
			name: 'Nations Mining Corporation',
			rfc: 'MIN991906-AR4',
			since: '1960',
			clientSince: '1995',
			parent: 19,
			owner: '',
			activity: 'minería, el transporte y la infraestructura.',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 21,
			code: '',
			type: 'Cliente',
			name: 'Infraestructura y Transportes Nacionales S.A. de C.V',
			rfc: 'MIN991906-AR4',
			since: '1960',
			clientSince: '1995',
			parent: 19,
			owner: '',
			activity: 'minería, el transporte y la infraestructura.',
			pais_cabecera: 'Mexico',
			examen: true,
		},
		{
			id: 22,
			code: '',
			type: 'Cliente',
			name: 'Proyectos y Desarrollos Nacionales S.A. de C.V',
			rfc: 'MIN991906-AR4',
			since: '1960',
			clientSince: '1995',
			parent: 19,
			owner: '',
			activity: 'minería, el transporte y la infraestructura.',
			pais_cabecera: 'Mexico',
			examen: true,
		},
	]
}